export type EventArea = any;

/**
 * Value stamped on the `EventArea` column when a caller does not supply one.
 */
export const DEFAULT_EVENT_AREA: EventArea = "NotSet";
